// import EmprestimoGarantiaCarro from '../components/templates/EmprestimoGarantiaCarro';

// export default function EmprestimoGarantiaCarroPage() {
//   return <EmprestimoGarantiaCarro />;
// }

import TabGroupEmprestimoGarantia from '@/components/molecules/TabGroupEmprestimoGarantia/TabGroupEmprestimoGarantia';
import { EmprestimoGarantiaTabs } from '@/data/misc/EmprestimoGarantiaTabs';

export default function renegociacaoSantanderFinanciamentos() {
  return <TabGroupEmprestimoGarantia tab={EmprestimoGarantiaTabs['emprestimo-garantia'].id} />;
}

export async function getStaticProps() {
  return {
    props: {},
  };
}
